import { formatInSiteZone } from 'common/services/dateService'

import type { JitsiTelehealthSession } from '../state/jitsiTelehealth.type'

const WALL_CLOCK_TIME = /^\d{2}:\d{2}(:\d{2})?$/

export const formatAppointmentTimeForDto = (value: string | Date, timeZone?: string): string => {
  if (typeof value === 'string' && WALL_CLOCK_TIME.test(value)) {
    return value.length === 5 ? `${value}:00` : value
  }

  return formatInSiteZone(value, timeZone, 'HH:mm:ss')
}

export const isJitsiTelehealthAvailable = (value: unknown): value is JitsiTelehealthSession => {
  if (value === null || value === undefined || typeof value !== 'object') {
    return false
  }

  const candidate = value as Record<string, unknown>

  return (
    typeof candidate.patient_short_link === 'string' &&
    candidate.patient_short_link.length > 0 &&
    typeof candidate.doctor_embed_url === 'string' &&
    candidate.doctor_embed_url.length > 0
  )
}
